module.exports = "/static/assets/95c0b916b508cfbc403ecd0843b7d80e.png";